import React from "react";
import SidebarComponent from "./SidebarComponent";
import HeaderComponent from "./HeaderComponent";
const AuthorizedLayoutComponent = ({ children }) => {
  return (
    <>
      <div className="wrapper">
        <SidebarComponent />
         <HeaderComponent />
        <div className="content-wrapper">{children}</div>
      </div>
    </>
  );
};

export default AuthorizedLayoutComponent;
